import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import config from 'appconfig';
import Info from '@atlaskit/icon/glyph/info';
import { colors } from '@atlaskit/theme';
import SectionMessage from '@atlaskit/section-message';
import { Dimensions } from '../../../components/visuals';
import { messages } from '../messages';

const infoIcon = () => <Info label="Info icon" primaryColor={colors.B400} />;

const InfoSectionMessage = styled.td`
  padding-top: ${Dimensions.units(3)}px;
`;

export const SingleQuoteTableContent = () => (
  <tr>
    <InfoSectionMessage colSpan={5}>
      <SectionMessage appearance="information" icon={infoIcon} testId="single-quote-banner">
        <FormattedMessage {...messages.ordersSingleQuote} />{' '}
        <a href={`${config.root}/my/billing/quotes`}>
          <FormattedMessage {...messages.ordersSingleQuoteLink} />
        </a>
      </SectionMessage>
    </InfoSectionMessage>
  </tr>
);

export const SingleInvoiceTableContent = () => (
  <tr>
    <InfoSectionMessage colSpan={5}>
      <SectionMessage appearance="information" icon={infoIcon} testId="single-invoice-banner">
        <FormattedMessage {...messages.ordersSingleInvoice} />{' '}
        <a href={`${config.root}/my/billing/paidorders`}>
          <FormattedMessage {...messages.ordersSingleInvoiceLink} />
        </a>
      </SectionMessage>
    </InfoSectionMessage>
  </tr>
);
